import webMap from './map.web'
import { $t } from '../i18n'
import { trace } from '../trace.js'
// gcoord.WGS84 	[lng,lat] 	WGS-84坐标系，GPS设备获取的经纬度坐标
// gcoord.GCJ02 	[lng,lat] 	GCJ-02坐标系，google中国地图、soso地图、aliyun地图、mapabc地图和高德地图所用的经纬度坐标
// gcoord.BD09 	[lng,lat] 	BD-09坐标系，百度地图采用的经纬度坐标
// gcoord.BD09LL 	[lng,lat] 	同BD09
// gcoord.BD09MC 	[x,y] 	BD-09米制坐标，百度地图采用的米制坐标，单位：米
// gcoord.BD09Meter 	[x,y] 	同BD09MC
// gcoord.Baidu 	[lng,lat] 	百度坐标系，BD-09坐标系别名，同BD-09
// gcoord.BMap 	[lng,lat] 	百度地图，BD-09坐标系别名，同BD-09
// gcoord.AMap 	[lng,lat] 	高德地图，同GCJ-02
// gcoord.WebMercator 	[x,y] 	Web Mercator投影，墨卡托投影，同EPSG3857，单位：米
// gcoord.WGS1984 	[lng,lat] 	WGS-84坐标系别名，同WGS-84
// gcoord.EPSG4326 	[lng,lat] 	WGS-84坐标系别名，同WGS-84
// gcoord.EPSG3857 	[x,y] 	Web Mercator投影，同WebMercator，单位：米
// gcoord.EPSG900913 	[x,y] 	Web Mercator投影，同WebMercator，单位：米

function getPositionByBrowerGps(sucCb, failCb) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (res) => {
        if (res.coords) {
          console.log('sucCbData', res.coords),
            sucCb(
              sucCbData({
                longitude: res.coords.longitude,
                latitude: res.coords.latitude,
                mapType: 'WGS84'
              })
            )
        } else {
          trace.log('location-msg', {
            from: 'web-map',
            msg: '定位失败: navigator.geolocation',
            data: {
              msg: 'res.coords is null'
            }
          })
          failCb(failCbData(null, 'res.coords is null'))
        }
      },
      (error) => {
        // https://developer.mozilla.org/zh-CN/docs/Web/API/GeolocationPositionError
        // 1	PERMISSION_DENIED	地理位置信息的获取失败，因为该页面没有获取地理位置信息的权限。
        // 2	POSITION_UNAVAILABLE	地理位置获取失败，因为至少有一个内部位置源返回一个内部错误。
        // 3	TIMEOUT	获取地理位置超时，通过定义PositionOptions.timeout 来设置获取地理位置的超时时长。
        console.error('navigator.geolocation ----err')
        console.error('code: ' + error.code + '\n' + 'message: ' + error.message + '\n')
        trace.log('location-msg', {
          from: 'web-map',
          msg: '定位失败: navigator.geolocation',
          data: {
            msg: 'error'
          }
        })
        failCb(
          failCbData(
            {
              message: error.message,
              code: error.code
            },
            error.message
          )
        )
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    )
  } else {
    trace.log('location-msg', {
      from: 'web-map',
      msg: '定位失败: navigator.geolocation',
      data: {
        msg: 'navigator.geolocation is NUll'
      }
    })
    failCb(failCbData(null, $t('liu-lan-qi-navigatorgeolocatio')))
  }
}

function isCityCenter(lng, lat) {
  let cityArr = [
    '121.48054,31.23593',
    '116.41339,39.91092',
    '113.27143,23.13534',
    '114.06455,22.54846',
    '104.07274,30.57899'
  ]

  let isCentry = false
  for (let i = 0; i < cityArr.length; i++) {
    let sliceArr = cityArr[i].split(',')
    // console.log(sliceArr);
    let lenStr = GetDistance(lng, lat, sliceArr[0], sliceArr[1])
    // console.log("lenStr+" + i, lenStr);
    // 位置小于200米
    if (lenStr < 200) {
      isCentry = true
      break
    }
  }
  console.log('isCityCenter', isCentry)
  return isCentry
}

function Rad(d) {
  return (d * Math.PI) / 180.0 //经纬度转换成三角函数中度分表形式。
}

//计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
function GetDistance(lat1, lng1, lat2, lng2) {
  let radLat1 = Rad(lat1)
  let radLat2 = Rad(lat2)
  let a = radLat1 - radLat2
  let b = Rad(lng1) - Rad(lng2)
  let s =
    2 *
    Math.asin(
      Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2))
    )
  s = s * 6378.137 // 地球半径，千米;
  s = Math.round(s * 10000) / 10000 //输出为公里
  s = Math.round(s * 1000) / 1 //单位修改为米,取整
  //s=s.toFixed(4);
  return s
}

function sucCbData(data) {
  return {
    code: 0,
    data: data
  }
}

function failCbData(err, msg) {
  console.log('failCbData', err, msg)
  return {
    code: -1,
    msg: msg || '',
    err: err
  }
}

//position.data.longitude, position.data.latitude
// 这里传入的坐标系为百度坐标系;返回的要求为gcj02

function handlerWithPos(longitude, latitude, callback) {
  let data = {}
  data.longitude = longitude
  data.latitude = latitude
  // 坐标统一都是GCJ02坐标系
  // console.log('百度坐标系====data', data)
  // data.type = gcoord.GCJ02.toLocaleLowerCase()
  try {
    Promise.resolve(data)
      .then(webMap.geocoder)
      .then((res) => {
        if (res.status === 0) {
          const ret = res.result
          // 这里使用的是百度坐标系,所以需要转成火星坐标系;
          // 返回的坐标,是纠正坐标; 感觉还不如用自身返回的坐标;

          // console.log('转成火星坐标系输出111'+JSON.stringify(transPoint))
          let paramsMsg = {
            province: ret.addressComponent.province,
            city: ret.addressComponent.city || ret.addressComponent.district,
            district: ret.addressComponent.district,
            address: ret.formatted_address,
            lon: data.longitude,
            lat: data.latitude,
            code: '0'
          }
          // console.log('转成火星坐标系输出222'+JSON.stringify(paramsMsg))
          callback(paramsMsg)
        } else {
          callback({ code: '-1', msg: $t('geocoder-zhuan-huan-fail') })
          // 第三方私有化部署,不要忘记配置百度地图域名白名单!!!
          console.error('geocoder 转换 fail!')
        }
      })
  } catch (err) {
    console.error(err)
    // 关于状态码
    callback({ code: '-1', msg: 'webMap.geocoder fail 2' })
  }
}

function mapReadyCb(sucCb, failCb) {
  const BMapGeo = new BMap.Geolocation()

  BMapGeo.enableSDKLocation()
  BMapGeo.getCurrentPosition(
    function (r) {
      console.log('百度地图结束定位时间戳' + new Date().getTime())
      console.log('r =' + JSON.stringify(r), r)
      if (this.getStatus() == BMAP_STATUS_SUCCESS) {
        if (isCityCenter(r.point.lng, r.point.lat)) {
          failCb(failCbData(null, $t('ding-wei-shi-bai')))
        } else {
          sucCb(
            sucCbData({
              longitude: r.point.lng,
              latitude: r.point.lat
            })
          )
        }
      } else {
        failCb(failCbData({ status: this.getStatus() }, 'geolocation.getCurrentPosition failed ' + this.getStatus()))
      }
    },
    {
      enableHighAccuracy: true, //是否要求高精度的地理位置信息
      timeout: 10000, //对地理位置信息的获取操作做超时限制
      maximumAge: 0 //设置缓存有效时间
    }
  )
}
function loadBaiduMapScript(succ, fail) {
  import('../LoadBaiduMapScript.js').then(({ LoadBaiduMapScript }) => {
    LoadBaiduMapScript(function (retData) {
      if (retData.code != 0) {
        fail()
      } else {
        succ()
      }
    })
  })
}
function getPositionByBd(sucCb, failCb) {
  if (window.BMap) {
    console.log('window.BMap is Ready....')
    mapReadyCb(sucCb, failCb)
  } else if (window.zzzconfig && window.zzzconfig.isBlockDomain && window.zzzconfig.isBlockDomain() == false) {
    loadBaiduMapScript(
      () => mapReadyCb(sucCb, failCb),
      () => {}
    )
  } else {
    console.log('BMap is not Ready....')
  }
}

const COORDINATE_MAPPINGS = {
  // 坐标系类型参数映射关系
  converSourceModel: {
    GCJ02: 'gcj02ll',
    BD09: 'bd09ll',
    WGS84: 'wgs84ll'
  },
  converTargetModel: {
    GCJ02: 'gcj02ll',
    BD09: 'bd09mc',
    WGS84: 'wgs84ll'
  },
  getGeoModel: {
    GCJ02: 'gc',
    BD09: 'bd',
    WGS84: 'gps'
  }
}
const RETURN_TYPE_MAPPINGS = {
  // 返回类型映射关系
  gcj02ll: 'GCJ02',
  'amap/tencent': 'GCJ02',
  bd09ll: 'BD09',
  bd09mc: 'BD09',
  wgs84ll: 'WGS84'
}

async function formatLocation(format = ['GCJ02'], isCity = false, locationInfo = {}) {
  console.log('isCity ~ 🚀 ', isCity)
  const formattedLocation = {}
  // 确保format是数组且包含GCJ02
  format = Array.isArray(format) ? format : ['GCJ02']
  if (!format.includes('GCJ02')) format.push('GCJ02')
  // 需要转换的坐标参数
  let conversionParams = []
  let getGeoParams = {}
  const sourceType = Object.keys(locationInfo)[0]
  // 组装接口参数
  format.forEach((type) => {
    if (locationInfo[type]) {
      // 如果已有该类型坐标，直接格式化
      formattedLocation[type] = {
        latitude: locationInfo[type]?.latitude || locationInfo[type]?.lat || 0,
        longitude: locationInfo[type]?.longitude || locationInfo[type]?.lon || 0
      }
    } else {
      // 需要坐标转换
      if (sourceType) {
        conversionParams.push({
          latitude: locationInfo[sourceType]?.latitude || locationInfo[sourceType]?.lat || 0,
          longitude: locationInfo[sourceType]?.longitude || locationInfo[sourceType]?.lon || 0,
          sourceModel: COORDINATE_MAPPINGS['converSourceModel'][sourceType],
          targetModel: COORDINATE_MAPPINGS['converTargetModel'][type]
        })
      }
    }
  })
  // 执行坐标转换
  if (conversionParams.length > 0) {
    const {
      data: { code, data }
    } = await window.$httpUtil.instance.post('/api/pp/common/district/convertGeoLocation', conversionParams)
    if (code === '0') {
      const changeLocationData = data
      changeLocationData.forEach((item) => {
        if (RETURN_TYPE_MAPPINGS[item.targetModel] && item.success) {
          formattedLocation[RETURN_TYPE_MAPPINGS[item.targetModel]] = {
            longitude: item.longitude,
            latitude: item.latitude
          }
        }
      })
    }
  }
  // 根据入参需要添加城市信息
  if (isCity && sourceType) {
    getGeoParams = {
      latitude: locationInfo[sourceType]?.latitude || locationInfo[sourceType]?.lat || 0,
      longitude: locationInfo[sourceType]?.longitude || locationInfo[sourceType]?.lon || 0,
      sourceModel: COORDINATE_MAPPINGS['getGeoModel'][sourceType],
      targetModel: COORDINATE_MAPPINGS['getGeoModel']['GCJ02'] // 接口默认要求传国策
    }
    if (
      getGeoParams['longitude'] &&
      getGeoParams['latitude'] &&
      getGeoParams['sourceModel'] &&
      getGeoParams['targetModel']
    ) {
      const {
        data: { code, data }
      } = await window.$httpUtil.instance.post('/api/pp/common/district/getGeoLocation', getGeoParams)
      if (code === '0') formattedLocation.city = data ? { ...data } : null
    }
  }
  return { code: 0, data: formattedLocation }
}

function getErrorInfo(error) {
  return {
    code: error.code,
    message: error.message || error.msg,
    PERMISSION_DENIED: error.PERMISSION_DENIED || Object.getPrototypeOf(error).PERMISSION_DENIED,
    POSITION_UNAVAILABLE: error.POSITION_UNAVAILABLE || Object.getPrototypeOf(error).POSITION_UNAVAILABLE,
    TIMEOUT: error.TIMEOUT || Object.getPrototypeOf(error).TIMEOUT
  }
}

export {
  getPositionByBrowerGps,
  getPositionByBd,
  // getPositionByGd,
  isCityCenter,
  handlerWithPos,
  formatLocation,
  getErrorInfo
}
